exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tooltip[data-v-b56ae538] {\n  max-width: 600px;\n}\n", ""]);

// exports
